module.exports = __webpack_public_path__ + "img/Bet 2.e253ed42.png";